module.exports = __webpack_public_path__ + "static/media/29FUNOV5.85a8fc60.jpg";